module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/shield-alt-f658ce8dd50db161d0ba97a32fd8e188.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/shield-alt.svg
// module id = ovda
// module chunks = 24